import React from 'react';
import { View, Text } from 'react-native';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import RoomControlSection from './roomControlSection';

const MASTER_TYPE_MAP = {
    lights: 'master-light',
    curtain: 'master-curtain',
    mur: 'mur',
    dnd: 'dnd',
};

const MasterControls = ({ onAction }) => {
    const getStyles = useCssStyle();
    const { t } = useTranslation();

    const master = useSelector(
        (state) => state.roomControlSlice?.data?.master
    );

    if (!master) return null;

    const groupLabels = {
        lights: t('room_control.master_light'),
        mur: t('room_control.master_mur'),
        dnd: t('room_control.master_dnd'),
    };

    return (
        <View style={getStyles(["roomControlsItemContainer", "roomMasterControlsItemContainer"])} id='roomControlsItemContainer roomMasterControlsItemContainer'>
            <Text style={getStyles(['label', 'roomControlsItemLabelText'])} id='label roomControlsItemLabelText'>
                {t('room_control.master')}
            </Text>

            <View style={getStyles(["roomControlsListItemMainContainer", "roomControlsMasterControls"])} id='roomControlsListItemMainContainer roomControlsMasterControls'>
                {Object.keys(master).map(key => (
                    <RoomControlSection
                        key={key}
                        // title={groupLabels[key] || key}
                        groups={master[key]}
                        type={MASTER_TYPE_MAP[key] || 'master'}
                        onAction={onAction}
                        styleKey={"master"}
                    />
                ))}
            </View>
        </View>
    );
};

export default MasterControls;